"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildHeader = void 0;
const tools_1 = require("@axiom-crypto/tools");
const halo2_lib_js_1 = require("@axiom-crypto/halo2-lib-js");
const utils_1 = require("../utils");
const data_1 = require("./data");
;
const buildHeader = (blockNumber) => {
    const getSubquery = (fieldIdx) => {
        let headerSubquery = {
            blockNumber: blockNumber.number(),
            fieldIdx: fieldIdx.number()
        };
        const dataSubquery = { subqueryData: headerSubquery, type: tools_1.DataSubqueryType.Header };
        return (0, data_1.prepData)(dataSubquery, [blockNumber, fieldIdx]);
    };
    const functions = Object.fromEntries(Object.keys(tools_1.HeaderField).map((key) => {
        return [(0, utils_1.lowercase)(key), () => {
                const headerField = (0, utils_1.getCircuitValueConstant)(tools_1.HeaderField[key]);
                return getSubquery(headerField);
            }];
    }));
    const logsBloom = async (logsBloomIdxRaw) => {
        if (logsBloomIdxRaw instanceof halo2_lib_js_1.CircuitValue) {
            throw new Error("logsBloomIdxRaw must be a constant (not a CircuitValue)");
        }
        const logsBloomIdx = (0, utils_1.getCircuitValueConstant)(logsBloomIdxRaw);
        if (logsBloomIdx.number() < 0 || logsBloomIdx.number() >= 8) {
            throw new Error("logsBloomIdx range is [0,8)");
        }
        const logIdxProcessed = (0, utils_1.getCircuitValueWithOffset)(logsBloomIdx, tools_1.AxiomV2FieldConstant.Header.LogsBloomFieldIdxOffset);
        return getSubquery(logIdxProcessed);
    };
    const functionsWithLogsBloom = { ...functions, logsBloom };
    return Object.freeze(functionsWithLogsBloom);
};
exports.buildHeader = buildHeader;
//# sourceMappingURL=header.js.map